module.exports = __webpack_public_path__ + "static/img/logo-mdao.eefb5720.png";